import { selectors__unoptimized as edgeSelectors } from '../../../ducks/resource-edges';
import { actionCreators as reqActionCreators } from '../../../ducks/request-status';


export const invalidateCacheAfterMove = ({ dispatch, items, dedupedFolders, dedupedAssets }) => {
  // invalidate the ancestors relationship of moved items
  // and any item that has an item we move as ancestors
  dedupedFolders.forEach((id) => {
    ['assets', 'folders', 'ancestors'].forEach((rel) => {
      dispatch(
        reqActionCreators.invalidateRelationship({
          id: id,
          type: 'folder',
          relationship: rel
        })
      );
    });
  });

  dedupedAssets.forEach((id) => {
    dispatch(
      reqActionCreators.invalidateRelationship({
        id: id,
        type: 'asset',
        relationship: 'ancestors'
      })
    );
  });

  // for generating new context path
  items
    .filter((item) => item.type === 'folder')
    .forEach((f) => {
      dispatch(
        reqActionCreators.invalidateResource({
          id: f.id,
          type: 'content-tree-node'
        })
      );
    });
}


export const collectAffectedCacheItems = ({ getState, items, targetFolderId, fromFolderId }) => {
  // for invalidating cache
  const relatedAssets = items
    .reduce((acc, item) => {
      const related = edgeSelectors.getRelatedResourcesByType(
        getState(),
        'asset',
        item
      );
      return [...acc, ...related];
    }, [])
    .map((f) => f.id);

  const relatedFolders = items
    .reduce((acc, item) => {
      const related = edgeSelectors.getRelatedResourcesByType(
        getState(),
        'folder',
        item
      );
      return [...acc, ...related];
    }, [])
    .map((f) => f.id);

  const dedupedAssets = relatedAssets.filter(
    (f, idx) => idx === relatedAssets.indexOf(f)
  );

  const allFolders = [...relatedFolders, targetFolderId, fromFolderId];
  const dedupedFolders = allFolders.filter(
    (f, idx) => idx === allFolders.indexOf(f)
  );

  return { dedupedAssets, dedupedFolders }
}